// import React, { useState, useEffect } from "react";
// import { getEmiBehavior } from "../API's/Actioncreator";
// import Loader from "../../../../presentationals/Loader/Loader.component";
// // import Loader from "../../../Component/Common/Loader.component";
// import EMIBehaviorCards from "./components/EMIBehaviorCards";
// import IncomeBarChart from "../common/IncomeBarChart";
// import IncomeDistributionPieChart from "../common/IncomeDistributionPieChart";

// import StageWiseAnalysisCards from "./components/StageWiseAnalysisCards";
// import EMIStageCollectionChart from "../common/EMIStageCollectionChart";

// import moment from "moment";

// function EmiBehavour({ selectedMonth, commonFilter }) {
//   const [emiBehaviorData, setEmiBehaviorData] = useState(null);
//   const [loading, setLoading] = useState(false);
//   const [error, setError] = useState(null);

//   // Fetch EMI behavior data when selectedMonth changes
//   useEffect(() => {
//     if (selectedMonth && selectedMonth.length > 0) {
//       setLoading(true);
//       setError(null);

//       const monthMap = {
//         Jan: 0, Feb: 1, Mar: 2, Apr: 3,
//         May: 4, Jun: 5, Jul: 6, Aug: 7,
//         Sep: 8, Oct: 9, Nov: 10, Dec: 11
//       };

//       const sortedMonths = [...selectedMonth].sort((a, b) => {
//         const [mA, yA] = a.split(" ");
//         const [mB, yB] = b.split(" ");

//         return new Date(yA, monthMap[mA]) - new Date(yB, monthMap[mB]);
//       });

//       const [startMonthName, startYear] = sortedMonths[0].split(" ");
//       const [endMonthName, endYear] =
//         sortedMonths[sortedMonths.length - 1].split(" ");

//       const startMonthIndex = monthMap[startMonthName];
//       const endMonthIndex = monthMap[endMonthName];

//       // const startDate = `01-${String(startMonthIndex + 1).padStart(2, "0")}-${startYear}`;

//       const lastDay = new Date(endYear, endMonthIndex + 1, 0).getDate();
//       // const endDate = `${lastDay}-${String(endMonthIndex + 1).padStart(2, "0")}-${endYear}`;

//       const startDate = moment(commonFilter?.fromDate, "YYYY-MM-DD").format("DD-MM-YYYY");
//       const endDate = moment(commonFilter?.toDate, "YYYY-MM-DD").format("DD-MM-YYYY");

//       // Fetch EMI behavior data
//       new Promise((resolve, reject) => {
//         getEmiBehavior(startDate, endDate,commonFilter?.nbfc ?? "", resolve, reject);
//       })
//         .then((response) => {
//           setLoading(false);
//           if (response.status === 200 && response.data) {
//             setEmiBehaviorData(response.data);
//           }
//         })
//         .catch((err) => {
//           setLoading(false);
//           setError("Failed to fetch EMI behavior data: " + err.message);
//         });
//     }
//   }, [selectedMonth, commonFilter]);

//   // Loading state
//   if (loading) {
//     return <Loader />;
//   }

//   // Error state
//   if (error) {
//     return (
//       <div style={{
//         display: 'flex',
//         justifyContent: 'center',
//         alignItems: 'center',
//         height: '400px',
//         color: '#EF4444',
//         fontSize: '16px'
//       }}>
//         {error}
//       </div>
//     );
//   }

//   // Map API data to component structure
//   const stages = emiBehaviorData?.stages || [];
//   const pieChartData = stages.map(stage => stage.activeLoans);
//   const pieChartLabels = stages.map(stage => stage.stageLabel);
//   const barChartCategories = stages.map(stage => stage.stageLabel);
//   const barChartData = stages.map(stage => stage.collectionRate);
//   const totalActiveLoans = emiBehaviorData?.totalActiveLoans || 0;

//   return (
//     <div>
//       <EMIBehaviorCards totalActiveLoans={totalActiveLoans} stages={stages} selectedMonth={selectedMonth} />
//       <div
//         style={{
//           display: "grid",
//           gridTemplateColumns: "1fr 1fr",
//           gap: "30px",
//           marginTop: "40px",
//         }}
//       >
//         <div
//           style={{
//             background: "#ffffff",
//             border: "1px solid #e5e7eb",
//             borderRadius: "14px",
//             padding: "20px",
//             boxShadow:
//               "0px 1px 2px rgba(0,0,0,0.10), 0px 1px 3px rgba(0,0,0,0.10)",
//           }}
//         >
//           <IncomeDistributionPieChart
//             title="EMI Stage Distribution"
//             labels={pieChartLabels}
//             series={pieChartData}
//             colors={["#3b82f6", "#22c55e", "#f59e0b"]}
//             showLegend={true}
//           />
//         </div>

//         <div
//           style={{
//             background: "#ffffff",
//             border: "1px solid #e5e7eb",
//             borderRadius: "14px",
//             padding: "20px",
//             boxShadow:
//               "0px 1px 2px rgba(0,0,0,0.10), 0px 1px 3px rgba(0,0,0,0.10)",
//           }}
//         >
//           <IncomeBarChart
//             title="Collection Rate by EMI Stage"
//             gridType="horizontal"
//             categories={barChartCategories}
//             showLegend={true}
//             series={[
//               {
//                 name: "Collection Rate %",
//                 data: barChartData,
//               },
//             ]}
//             colors={["#10b981"]}
//           />
//         </div>
//       </div>
//       <div
//         style={{
//           background: "#ffffff",
//           border: "1px solid #e5e7eb",
//           borderRadius: "14px",
//           padding: "20px",
//           boxShadow:
//             "0px 1px 2px rgba(0,0,0,0.10), 0px 1px 3px rgba(0,0,0,0.10)",
//           marginTop: "40px",
//           marginBottom: "40px",
//         }}
//       >
//         <EMIStageCollectionChart stages={stages} />
//       </div>
//       <StageWiseAnalysisCards stages={stages} />
//     </div>
//   );
// }

// export default EmiBehavour;

import React, { useState, useEffect, useRef } from "react";
import { getEmiBehavior } from "../API's/Actioncreator";
import EMIBehaviorCards from "./components/EMIBehaviorCards";
import IncomeBarChart from "../common/IncomeBarChart";
import IncomeDistributionPieChart from "../common/IncomeDistributionPieChart";
import StageWiseAnalysisCards from "./components/StageWiseAnalysisCards";
import EMIStageCollectionChart from "../common/EMIStageCollectionChart";
import moment from "moment";

function EmiBehavour({ selectedMonth, commonFilter }) {
  const abortControllerRef = useRef(null);
  // default true → skeleton shows immediately on mount
  const [loading, setLoading] = useState(true);
  const [emiBehaviorData, setEmiBehaviorData] = useState(null);
  const [error, setError] = useState(null);

  const cancelAndReset = () => {
    abortControllerRef.current?.abort();
    abortControllerRef.current = new AbortController();
    setEmiBehaviorData(null);
    setLoading(true);
    setError(null);
  };

  useEffect(() => {
    if (!selectedMonth || selectedMonth.length === 0) return;

    cancelAndReset();
    const signal = abortControllerRef.current.signal;

    const startDate = moment(commonFilter?.fromDate, "YYYY-MM-DD").format("DD-MM-YYYY");
    const endDate   = moment(commonFilter?.toDate,   "YYYY-MM-DD").format("DD-MM-YYYY");
    const nbfc      = commonFilter?.nbfc ?? "";

    new Promise((resolve, reject) => {
      getEmiBehavior(startDate, endDate, nbfc, resolve, reject);
    })
      .then((response) => {
        if (signal.aborted) return;
        setLoading(false);
        if (response?.status === 200 && response?.data) {
          setEmiBehaviorData(response.data);
        }
      })
      .catch((err) => {
        if (signal.aborted) return;
        setLoading(false);
        setError("Failed to fetch EMI behavior data: " + err?.message);
      });

    return () => {
      abortControllerRef.current?.abort();
    };
  }, [selectedMonth, commonFilter]);

  if (error) {
    return (
      <div style={{ display: "flex", justifyContent: "center", alignItems: "center", height: "400px", color: "#EF4444", fontSize: "16px" }}>
        {error}
      </div>
    );
  }

  const stages = emiBehaviorData?.stages || [];
  const pieChartData     = stages.map(s => s.activeLoans);
  const pieChartLabels   = stages.map(s => s.stageLabel);
  const barChartCategories = stages.map(s => s.stageLabel);
  const barChartData     = stages.map(s => s.collectionRate);
  const totalActiveLoans = emiBehaviorData?.totalActiveLoans || 0;

  return (
    <div>
      {/* Cards — has its own skeleton */}
      <EMIBehaviorCards
        totalActiveLoans={totalActiveLoans}
        stages={stages}
        selectedMonth={selectedMonth}
        loading={loading}
      />

      {/* Charts — hidden while loading */}
      {!loading && (
        <>
          <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: "30px", marginTop: "40px" }}>
            <div style={{ background: "#ffffff", border: "1px solid #e5e7eb", borderRadius: "14px", padding: "20px", boxShadow: "0px 1px 2px rgba(0,0,0,0.10), 0px 1px 3px rgba(0,0,0,0.10)" }}>
              <IncomeDistributionPieChart
                title="EMI Stage Distribution"
                labels={pieChartLabels}
                series={pieChartData}
                colors={["#3b82f6", "#22c55e", "#f59e0b"]}
                showLegend={true}
              />
            </div>
            <div style={{ background: "#ffffff", border: "1px solid #e5e7eb", borderRadius: "14px", padding: "20px", boxShadow: "0px 1px 2px rgba(0,0,0,0.10), 0px 1px 3px rgba(0,0,0,0.10)" }}>
              <IncomeBarChart
                title="Collection Rate by EMI Stage"
                gridType="horizontal"
                categories={barChartCategories}
                showLegend={true}
                series={[{ name: "Collection Rate %", data: barChartData }]}
                colors={["#10b981"]}
              />
            </div>
          </div>

          <div style={{ background: "#ffffff", border: "1px solid #e5e7eb", borderRadius: "14px", padding: "20px", boxShadow: "0px 1px 2px rgba(0,0,0,0.10), 0px 1px 3px rgba(0,0,0,0.10)", marginTop: "40px", marginBottom: "40px" }}>
            <EMIStageCollectionChart stages={stages} />
          </div>
        </>
      )}

      {/* Stage cards + chart skeletons when loading */}
      {loading && (
        <>
          <EMIChartsSkeleton />
          <EMIStageChartSkeleton />
        </>
      )}

      <StageWiseAnalysisCards stages={stages} loading={loading} />
    </div>
  );
}

export default EmiBehavour;


const skStyle = {
  background: "linear-gradient(90deg,#f0f0f0 25%,#e0e0e0 50%,#f0f0f0 75%)",
  backgroundSize: "600px 100%",
  animation: "shimmer 1.4s infinite linear",
  borderRadius: "6px",
};

function EMIChartsSkeleton() {
  return (
    <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: "30px", marginTop: "40px" }}>
      {[1, 2].map(i => (
        <div key={i} style={{ background: "#fff", border: "1px solid #e5e7eb", borderRadius: "14px", padding: "20px", boxShadow: "0px 1px 2px rgba(0,0,0,0.10)" }}>
          <div style={{ ...skStyle, width: "160px", height: "18px", marginBottom: "20px" }} />
          <div style={{ display: "flex", alignItems: "center", justifyContent: "center", height: "200px" }}>
            <div style={{ ...skStyle, width: "160px", height: "160px", borderRadius: "50%" }} />
          </div>
        </div>
      ))}
    </div>
  );
}

function EMIStageChartSkeleton() {
  return (
    <div style={{ background: "#fff", border: "1px solid #e5e7eb", borderRadius: "14px", padding: "20px", boxShadow: "0px 1px 2px rgba(0,0,0,0.10)", marginTop: "40px", marginBottom: "40px" }}>
      <div style={{ ...skStyle, width: "260px", height: "20px", marginBottom: "24px" }} />
      <div style={{ display: "flex", alignItems: "flex-end", gap: "16px", height: "160px", padding: "0 10px" }}>
        {[120, 90, 60].map((h, i) => (
          <div key={i} style={{ flex: 1, display: "flex", gap: "6px", alignItems: "flex-end" }}>
            <div style={{ ...skStyle, flex: 1, height: `${h}px`, borderRadius: "4px 4px 0 0" }} />
            <div style={{ ...skStyle, flex: 1, height: `${Math.round(h * 0.7)}px`, borderRadius: "4px 4px 0 0" }} />
          </div>
        ))}
      </div>
    </div>
  );
}